import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "projects/tilmanagement/src/environments/environment";
import { PlantAdmins, PlantTilAdmins } from "../../interfaces/technical-letters/plant-admins.interface";
import { Plant } from "../../interfaces/asset-hierarchy/asset-hierarchy.models";
import { DeletedLetterLog } from "../../interfaces/technical-letters/deleted-letter-logs.interface";

@Injectable({
  providedIn: "root",
})
export class PlantAdminsService {
  private readonly apiUrl = `${environment.apiUrl}/technical-letters`;

  constructor(private http: HttpClient) {}

  /**
   * Get all plant admins
   */
  getPlantAdmins(): Observable<PlantAdmins[]> {
    return this.http.get<PlantAdmins[]>(`${this.apiUrl}/plant-admins`);
  }

  getPlants(): Observable<Plant[]> {
    return this.http.get<Plant[]>(`${this.apiUrl}/plants`);
  }

  createEditPlantAdmins(plantAdmins: PlantTilAdmins): Observable<{message: string}> {
    return this.http.post<{message: string}>(
      `${this.apiUrl}/plant-admins/add-edit`,
      plantAdmins
    );
  }

  deletePlantAdmin(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/plant-admins/delete/${id}`);
  }

  getDeletedLetterLogs(): Observable<DeletedLetterLog[]> {
    return this.http.get<DeletedLetterLog[]>(`${this.apiUrl}/deleted-letter-logs`);
  }
}
